__turbopack_context__.v({
  "fact": "story-facts-module__Pw_H2W__fact",
  "infinite": "story-facts-module__Pw_H2W__infinite",
  "infinity-settle": "story-facts-module__Pw_H2W__infinity-settle",
  "label": "story-facts-module__Pw_H2W__label",
  "rush": "story-facts-module__Pw_H2W__rush",
  "value": "story-facts-module__Pw_H2W__value",
});
